import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useDistrictBulkProcessingConfigGet = (options) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v2/district-bulk-processing-configuration/`;
  return useRestQuery(requestUrl, options);
};

export default useDistrictBulkProcessingConfigGet;
